export default function formatPaymentMethodFlag(type: string): string {
  return type?.replace('-', '').replace('_', '').toLowerCase();
}
